import axios from "axios";
import React, { useEffect, useState, Component } from "react";
import "./Top_selling_card.css";
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import "./home_middle.css";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import explore from '../../Pages/Collections/Im/hcexplore.png';
import DatePicker from 'react-date-picker';
import ShareButton from "react-web-share-button";


const divStyle = {
    borderColor: 'white',
    backgroundColor:'#000014',
    borderRadius: '50px',
    color: 'white',
   
  };


function Cards_Chandramukhi(props) {
 
    const [value, onChange] = useState(new Date());
    let history = useHistory();
    const responsive = {
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          partialVisibilityGutter: 30
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
          },
      };
    
    const [APIData, setAPIData] = useState([]);
    const [nftCount, setNftCount] = useState(8);
    const loadMoreNft = () => {
        setNftCount(nftCount + 8);
      };
    const [filteredData,setFilteredData] = useState([]);
    const handleSearch = (event) =>{
        const selectValue = event.target.value;
     //   console.log(selectValue);
        let result = new Array();
        result = APIData.filter((data) => {
            if ( data.price == selectValue ){
                return data;
            }
            if ( data.film_name == selectValue ){
                return data;
            }
            });
            console.log(result);
            setFilteredData(result);
    }
    
    useEffect(() => {
        const sendGetRequest = async () => {
            try {
                const resp = await axios.get(`https://us-central1-diginoor-3755e.cloudfunctions.net/app/NFT/all`)
                .then((resp) => {
                   // const nftData = response.data;
                    setAPIData(resp.data);
                    setFilteredData(resp.data);
                    console.log(resp.data);
                    
                });
            
            } catch (err) {
                // Handle Error Here
                console.error(err);
            }
        };
        sendGetRequest();
        
    }, []);

    return (
        <>
        <div className="top-sellers top-sellers-d">
{filteredData.map((data) => {
    if (data.film_name === "Chandramukhi"){
    return (
        <div  key={data._id} className="top-carrdd">
            <div id="top-card" className={
                data.collection=="Rare" ? "rare-card top-card" 
                : data.collection =="Legendary" ? "legendary-card top-card"
                : data.collection =="Ultimate" ? "ultimate-card top-card" 
                : "top-card"}>
                
                <img src={data.seller} className="lo" />
                <img src={data.film_image} className="lo" />
                <img src={data.seller} className="lo" />
                <div className="ts-dropdown">
               
  <button className="dropbtn"><i className="glyphicon glyphicon-option-horizontal"></i></button>
  <div className="dropdown-content" >
  <p><Link to="">Report</Link></p>
  <p><Link to="">Share</Link></p>
  </div>

                </div>
                <div>
{/* <img className="" src={} alt="Logo" /> */}
<Link to={`/nftdetail/${data.id}`}> <img src={data.nft_thumb} className="top-im" /></Link>
                </div>
                <div className="top-details">

              {/*  <a className="top-card-title" href={'/nftfinal/'+data.id}>{data.nft_title}</a>   */}  

                <Link to={`/nftdetail/${data.id}`}><p className="top-card-title"> {data.nft_title}</p></Link> 
                <p id="collection" className="top-card-title1">{data.collection}</p>
                <Link to={`/nftdetail/${data.id}`}> <p className="top-card-title-price">${data.price} </p></Link>
              
                
                </div>
                <div className="like">
                <FormControlLabel
        control={<Checkbox icon={<FavoriteBorder />} 
                  checkedIcon={<Favorite />}
          name="checkedH" />}
      />
                </div>
            </div>
           
        </div>
    )
    }
})}
</div>


<div className="top-sellers top-sellers-tb">


{/* <h1 className="thead">TOP SELLERS</h1> */}
<Carousel 
responsive={responsive}
autoPlay={true}
autoPlaySpeed={5000}
infinite={true}
>
{filteredData.map((data) => {
    if(data.film_name === "Chandramukhi"){
return (
<Link to={`/nftdetail/${data.id}`}>
<div  key={data._id} className="top-carrdd">
{/* card1...................................... */}
<div id="top-card" className={
                data.collection=="Rare" ? "rare-card top-card" 
                : data.collection =="Legendary" ? "legendary-card top-card"
                : data.collection =="Ultimate" ? "ultimate-card top-card" 
                : "top-card"}>
    
    <img src={data.seller} className="lo" />
    <img src={data.film_image} className="lo" />
    <img src={data.seller} className="lo" />
    <div className="ts-dropdown">
   
<button className="dropbtn"><i className="glyphicon glyphicon-option-horizontal"></i></button>
<div className="dropdown-content" >
<p><Link to="/contact">Report</Link></p>
<p><ShareButton buttonStyle={divStyle}/></p>
</div>

    </div>
    <div>
{/* <img className="" src={} alt="Logo" /> */}
<Link to={`/nftdetail/${data.id}`}> <img src={data.nft_thumb} className="top-im" /></Link>
    </div>
    <div className="top-details">

  {/*  <a className="top-card-title" href={'/nftfinal/'+data.id}>{data.nft_title}</a>   */}  

    <Link to={`/nftdetail/${data.id}`}><p className="top-card-title"> {data.nft_title}</p></Link> 
    <p id="collection" className="top-card-title1">{data.collection}</p>
    <Link to={`/nftdetail/${data.id}`}> <p className="top-card-title-price">${data.price} </p></Link>
  
    
    </div>
    <div className="like">
    <FormControlLabel
control={<Checkbox icon={<FavoriteBorder />} 
      checkedIcon={<Favorite />}
name="checkedH" />}
/>
    </div>
</div>

</div>
</Link>
)
    }
})}
</Carousel>
</div>
        </>
    )
    
}

export default Cards_Chandramukhi